import React, { useEffect, useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import Table from '../table/Table';
import { ApiWebhook } from '../api';
import WebhookModal from './WebhookModal';
import WebhookRequests from './requests/WebhookRequests';
import { webhookApi } from '../apis';
import { DropdownWrapper } from '../common/DropdownWrapper';
import { WebhookTest } from './WebhookTest';
import SalvPage from '../common/SalvPage';

export const Webhooks = () => {
  const [page, setPage] = useState(0);
  const size = 20;
  const [total, setTotal] = useState(0);
  const [webhooks, setWebhooks] = useState<ApiWebhook[]>([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [webhook, setWebhook] = useState<ApiWebhook | null>(null);

  useEffect(() => {
    fetch(page, size);
  }, [page]);

  const fetch = async (page: number, size: number) => {
    const webhooksPage = await webhookApi.findWebhooks({ page, size });
    setWebhooks(webhooksPage.content);
    setTotal(webhooksPage.total);
  };

  const addWebhook = async () => {
    setWebhook(null);
    setShowEditModal(true);
  };

  const editWebhook = async (webhook: ApiWebhook) => {
    setWebhook(webhook);
    setShowEditModal(true);
  };

  const onComplete = async (webhook?: ApiWebhook) => {
    setShowEditModal(false);
    setWebhook(null);
    if (webhook) {
      await fetch(page, size);
    }
  };

  return (
    <SalvPage title={'Webhooks'}>
      <Table
        responsive={false}
        data-testid='table'
        total={total}
        page={page}
        size={size}
        items={webhooks}
        fetchPage={setPage}
        actions={() => (
          <Button data-testid='add-button' variant='info' size='sm' className='btn-white' onClick={addWebhook}>
            Add new webhook
          </Button>
        )}
        header={() => (
          <tr>
            <th>ID</th>
            <th>Url</th>
            <th>Triggers</th>
            <th className='text-end'>Actions</th>
          </tr>
        )}
        body={(webhooks) =>
          webhooks.map((webhook: ApiWebhook, index) => (
            <tr key={webhook.id} className={`custom-table-row-${index % 2}`}>
              <td>{webhook.id}</td>
              <td>{webhook.url}</td>
              <td>{webhook.trigger}</td>
              <td className='text-end'>
                <DropdownWrapper align='end'>
                  <Dropdown.Toggle as={Button} size='sm' className='btn-white' id='actions-dropdown'>
                    •••
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Button onClick={() => editWebhook(webhook)} className='dropdown-item' variant='outline-info'>
                      Edit
                    </Button>
                    <WebhookTest webhook={webhook} />
                  </Dropdown.Menu>
                </DropdownWrapper>
              </td>
            </tr>
          ))
        }
      />
      <WebhookModal data-testid='modal' show={showEditModal} webhook={webhook} onComplete={onComplete} />
      <WebhookRequests />
    </SalvPage>
  );
};

export default Webhooks;
